@if (employee()) {
  <div
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    class="h-5 w-5 md:h-7 md:w-7"
    (mouseenter)="isOpen = true"
    (mouseleave)="isOpen = false">
    <img [src]="employeeImage" alt="profile" />
  </div>
  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayWidth]="300"
    [cdkConnectedOverlayOpen]="isOpen">
    <div
      class="absolute m-1 flex w-fit flex-col gap-2.5 rounded bg-gray-700 p-2.5 text-white">
      <div class="text-sm font-medium">
        {{ employee()?.employee ?? '' }}
        <mat-divider class="border-white" />
        {{ employee()?.jobPosition ?? '' }}
      </div>
      <div class="text-xs font-medium">
        Potencial : {{ employee().potentialScore ?? 0 | number: '1.0-2' }}%
        <mat-divider class="border-white" />
        Desempeño : {{ employee().scorePerformance ?? 0 | number: '1.0-2' }}%
      </div>
    </div>
  </ng-template>
}
